import type { ElementKey } from '@/lib/experience'

interface Props {
  element: ElementKey
  size?: number
}

// Classical alchemical symbols
function ElementSigil({ element, size = 120 }: Props) {
  const s = size
  const strokeColor = {
    terra: '#8FAE6F',
    agua: '#5FA0D9',
    fogo: '#F09A5E',
    ar: '#D4C3EA',
  }[element]

  const render = () => {
    const cx = s / 2
    const cy = s / 2
    const r = s * 0.38

    switch (element) {
      case 'terra':
        // Downward triangle with horizontal line (earth)
        return (
          <>
            <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={strokeColor} strokeWidth={0.5} opacity={0.3} />
            <polygon
              points={`${cx},${cy + r} ${cx - r * 0.9},${cy - r * 0.5} ${cx + r * 0.9},${cy - r * 0.5}`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={1.2}
            />
            <line
              x1={cx - r * 0.55}
              y1={cy - r * 0.05}
              x2={cx + r * 0.55}
              y2={cy - r * 0.05}
              stroke={strokeColor}
              strokeWidth={1.2}
            />
          </>
        )
      case 'agua':
        // Downward triangle (water)
        return (
          <>
            <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={strokeColor} strokeWidth={0.5} opacity={0.3} />
            <polygon
              points={`${cx},${cy + r} ${cx - r * 0.9},${cy - r * 0.5} ${cx + r * 0.9},${cy - r * 0.5}`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={1.2}
            />
          </>
        )
      case 'fogo':
        // Upward triangle (fire)
        return (
          <>
            <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={strokeColor} strokeWidth={0.5} opacity={0.3} />
            <polygon
              points={`${cx},${cy - r} ${cx - r * 0.9},${cy + r * 0.5} ${cx + r * 0.9},${cy + r * 0.5}`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={1.2}
            />
          </>
        )
      case 'ar':
        // Upward triangle with horizontal line (air)
        return (
          <>
            <circle cx={cx} cy={cy} r={r + 6} fill="none" stroke={strokeColor} strokeWidth={0.5} opacity={0.3} />
            <polygon
              points={`${cx},${cy - r} ${cx - r * 0.9},${cy + r * 0.5} ${cx + r * 0.9},${cy + r * 0.5}`}
              fill="none"
              stroke={strokeColor}
              strokeWidth={1.2}
            />
            <line
              x1={cx - r * 0.55}
              y1={cy + r * 0.05}
              x2={cx + r * 0.55}
              y2={cy + r * 0.05}
              stroke={strokeColor}
              strokeWidth={1.2}
            />
          </>
        )
    }
  }

  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} className="animate-drift">
      {render()}
    </svg>
  )
}

export default ElementSigil
